import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TDashboardApi } from './types';

export const dashboard: TDashboardApi = {
	getTotalTaxes: payload =>
		http.post(endpoint.dashboard.EM_TOTAL_TAXES, payload).then(response => response.data),
	getSalesInfo: payload =>
		http.post(endpoint.dashboard.EM_SALES_INFO, payload).then(response => response.data),
	getMonthlySalesInfo: payload =>
		http.post(endpoint.dashboard.EM_MONTHLY_SALES_INFO, payload).then(response => response.data),
};
